import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, StrategicAxis } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeStrategicAxis(
    request: Boundaries["removeStrategicAxis"]["request"],
  ): void;
}

function useRemoveStrategicAxis(
  strategicAxis: Identifiable<StrategicAxis>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveStrategicAxisRequestPending(strategicAxis),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveStrategicAxisRequestSuccess(strategicAxis),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveStrategicAxisRequestFailure(strategicAxis),
    ),
    removeStrategicAxis: core.removeStrategicAxis,
  };
}

export { useRemoveStrategicAxis };
